/* eslint-disable global-require */
module.exports = [...require('./contents/Locked/i18n'), ...require('./contents/NoEmail/i18n'), 'subscription.payment_ok.m13', 'subscription.payment_ok.m12', 'tour.emailvalidationneeded.section.title1'];
